import { DependencyList, useEffect } from 'react';
import { AppState, useAppStore } from '../stores/app.store';

export function useLayout(getState: () => Partial<AppState>, deps?: DependencyList): void {
  const updateLayout = useAppStore((s) => s.updateLayout);

  useEffect(() => {
    updateLayout({
      loading: undefined,
      title: undefined,
      titleSize: undefined,
      backButton: undefined,
      onBack: undefined,
      hideFooter: undefined,
      activeMenu: undefined,
      ...getState(),
    });
  }, deps);
}
